import { render } from "./EditGroupPermission.vue?vue&type=template&id=f481f7d2&scoped=true&ts=true"
import script from "./EditGroupPermission.vue?vue&type=script&lang=ts"
export * from "./EditGroupPermission.vue?vue&type=script&lang=ts"

import "./EditGroupPermission.vue?vue&type=style&index=0&id=f481f7d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f481f7d2"]])

export default __exports__